export function setParams(state, params){
    state.params = params
}
export function setLoading(state, loading){
    state.loading.module = loading
}

export function setReportData(state, data) {
    state.data_report = data;
}

export function setDateRangeParam(state) {
    // Seteamos la fecha
    var dt = new Date();
    // Fecha Actual
    let d = dt.toISOString().substring(0, 10);
    //Hace 30 Dias
    dt.setDate(dt.getDate() - 30);
    let date = dt.toISOString().substring(0, 10);

    state.params.from_date = date
}

export function validate_search(state,data){

    const old_row = state.data_report.find( item => item.document_id == data.document_id)
    if (data.tot_dif === 0){
        state.data_report = state.data_report.filter(function(item) { return item.document_id !== data.document_id });
    }else{
        state.data_report = state.data_report.map(p =>
            p.document_id === data.document_id
                ? { ...p, tot_dif: data.tot_dif }
                : p
        );
    }

}



// WEBPACK FOOTER //
// ./src/modules/inventory-reconciliation/mutations.js